import { createContext, useContext, useState, useEffect, type ReactNode } from 'react';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbContextValue {
  breadcrumbs: BreadcrumbItem[];
  setBreadcrumbs: (items: BreadcrumbItem[]) => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextValue>({
  breadcrumbs: [],
  setBreadcrumbs: () => {},
});

export function BreadcrumbProvider({ children }: { children: ReactNode }) {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([]);

  return (
    <BreadcrumbContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

/** Read current breadcrumbs */
export function useBreadcrumbs() {
  return useContext(BreadcrumbContext).breadcrumbs;
}

/** Set breadcrumbs on mount, clear on unmount */
export function useSetBreadcrumbs(items: BreadcrumbItem[]) {
  const { setBreadcrumbs } = useContext(BreadcrumbContext);

  useEffect(() => {
    setBreadcrumbs(items);
    return () => setBreadcrumbs([]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setBreadcrumbs, JSON.stringify(items)]);
}
